import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const intercomConversationsApi = createApi({
  reducerPath: 'intercomConversationsApi',
  baseQuery: createBaseQuery('intercom_conversations'),
  tagTypes: ['IntercomConversations'],
  endpoints: builder => ({
    getIntercomConversations: builder.query({
      query: candidateId => `/candidate/${candidateId}`,
      transformResponse: ({ result }) => result,
      providesTags: (result, error, candidateId) => [
        { type: 'IntercomConversations', id: candidateId },
      ],
    }),
    createIntercomConversation: builder.mutation({
      query: ({ candidateId, data }) => ({
        url: `/candidate/${candidateId}`,
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: (result, error, { candidateId }) => [
        { type: 'IntercomConversations', id: candidateId },
      ],
    }),
    updateIntercomConversation: builder.mutation({
      query: ({ id, candidateId, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: (result, error, { candidateId }) => [
        { type: 'IntercomConversations', id: candidateId },
      ],
    }),
  }),
});

export const {
  useGetIntercomConversationsQuery,
  useCreateIntercomConversationMutation,
  useUpdateIntercomConversationMutation,
} = intercomConversationsApi;
